import m from "../../geodata/es2015/saintVincentHigh";
window.am4geodata_saintVincentHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/saintVincentHigh.js
// module id = null
// module chunks = 